module.exports = __webpack_public_path__ + "static/sec2-bg-1dbe7d9ad9a847ec67088445522babba.png";